export enum AnaglyphOrientation {
  RedCyan = "red-cyan",
  CyanRed = "cyan-red",
  RedGreen = "red-green",
  GreenRed = "green-red",
}

export interface AnaglyphClinicPrefs {
  default_anaglyph_orientation?: AnaglyphOrientation | null;
  disallow_different_glasses?: boolean;
}

export interface AnaglyphAppConfig {
  default_anaglyph_orientation?: string;
}

export function isAnaglyphOrientation(value: unknown): value is AnaglyphOrientation {
  return Object.values(AnaglyphOrientation).includes(value as AnaglyphOrientation);
}

export function defaultAnaglyphOrientation(
  clinic_prefs?: AnaglyphClinicPrefs | null,
  app_config?: AnaglyphAppConfig | null,
): AnaglyphOrientation {
  const clinic_orientation =
    clinic_prefs && clinic_prefs.default_anaglyph_orientation;
  if (isAnaglyphOrientation(clinic_orientation)) {
    return clinic_orientation;
  }
  const app_orientation = app_config && app_config.default_anaglyph_orientation;
  if (isAnaglyphOrientation(app_orientation)) {
    return app_orientation;
  }
  return AnaglyphOrientation.CyanRed;
}

export function effectiveAnaglyphOrientation(
  saved_orientation?: AnaglyphOrientation | null,
  clinic_prefs?: AnaglyphClinicPrefs | null,
  app_config?: AnaglyphAppConfig | null,
): AnaglyphOrientation {
  const clinic_default = defaultAnaglyphOrientation(clinic_prefs, app_config);
  if (clinic_prefs && clinic_prefs.disallow_different_glasses) {
    return clinic_default;
  }
  return isAnaglyphOrientation(saved_orientation) ? saved_orientation : clinic_default;
}
